// src/sim/stamina/constants.ts — P3 stamina clamp constants (D-28).
//
// Source: .planning/phases/03-core-sim-primitives/03-CONTEXT.md D-28.

export const P3_STAMINA_MIN = 0;
export const P3_STAMINA_MAX = 1;
